import { dropCookie } from './dropCookie';
import {
    secureStorage_clear,
    secureStorage_getItem,
    secureStorage_removeItem
} from './secureStorage';

export const resetStorage = () => {
    // Check if we're in authentication flow
    const urlParams = new URLSearchParams(window.location.search);
    const isAuthFlow = urlParams.get('code') !== null;

    // List of items to preserve during auth flow
    const authItems = [
        'vlomni_auth_code',
        'vlomni_auth_timestamp',
        'vlomni_login_source',
        'vlomni_session_active',
        'vlomni_access_token',
        'vlomni_id_token',
        'vlomni_refresh_token',
        'vlomni_login_username',
        'vlomni_user_info',
        'vlomni_user_status',
        'hubspot_enabled',
        'accesstoken',
        'refreshtoken',
        'updatetoken',
        'expiresin',
        'memoryuser'
    ];

    // If in auth flow, only remove non-auth items
    if (isAuthFlow) {
        // console.log('In auth flow, preserving auth-related items');
        // Get all current keys from secureStorage
        const keys = Object.keys(window.localStorage);
        const secureKeys = keys.filter(key => secureStorage_getItem(key) !== '');

        // Remove only non-auth items
        secureKeys.forEach(key => {
            if (!authItems.includes(key)) {
                secureStorage_removeItem(key);
            }
        });

        // Remove specific items that should always be cleared
        secureStorage_removeItem("apiurl");
        secureStorage_removeItem("bucketurl");
        secureStorage_removeItem("storeadminurl");
        secureStorage_removeItem('userAvatar');
        secureStorage_removeItem('main_user_Avatar');
    } else {
        // Not in auth flow, clear everything except memoryuser        
        const exceptions = ['memoryuser'];
        const keys = Object.keys(window.localStorage);
        const secureKeys = keys.filter(key => secureStorage_getItem(key) !== '');

        secureKeys.forEach(key => {
            if (!exceptions.includes(key)) {
                secureStorage_removeItem(key);
            }
        });
    }

    // Always clear these secure storage items
    secureStorage_removeItem('customername');
    secureStorage_removeItem('secondary_customerids');
    secureStorage_removeItem('selected_customername');
    secureStorage_removeItem('accountstatus');
    secureStorage_removeItem('access');
    secureStorage_removeItem('PaymentGateway');
    secureStorage_removeItem('PaymentGatewayID');
    secureStorage_removeItem('CompanyID');
    secureStorage_removeItem('EDIstatus');
    secureStorage_removeItem('workflows');
    secureStorage_removeItem('database');
    secureStorage_removeItem('CustomerID');

    // Only clear cookies if not in auth flow
    if (!isAuthFlow) {
        dropCookie('vlomni-cookie-loggedin', '', 0);
        dropCookie('vlomni-cookie-active', '', 0);
    }

    // Clear all cookies except auth-related ones
    document.cookie.split(";").forEach(function (c) {
        const [name] = c.trim().split("=");
        if (!name.startsWith('vlomni-')) {
            document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        }
    });
};